import React from 'react';
import Tab from '../webcommon/header/tab/Tab';
import { withRouter } from 'react-router';
import styles from './Summary.module.scss';
import tabStyles from './TabOverride.module.scss';
import StatusPage from './statusPage/statusPage';
import UserProfile from './userProfile/userProfile';

export default (withRouter(() => (
    <div className={ styles.summary }>
        <div className={ styles.header }>
            Settings
        </div>
        <div className={ styles.tabContainer }>
            <Tab
                rememberLastTab
                styles={ tabStyles }
                tabs={ [
                    {
                        title: 'Status Page',
                        path: '/status',
                        component: StatusPage
                    }
                    ,{
                        title: 'User Profile',
                        path: '/userProfile',
                        component: UserProfile
                    },
                
                ] }
            />
        </div>
    </div>
)));
